const prepareProviderLink = (tracking) => {
  const upsRegex = /\b1Z[A-Z0-9]{16}\b/;
  const uspsRegex = /\b(?:94|93|92|95|96|82|70|14|03)[0-9]{20,22}\b/;
  // Пояснення:
  // USPS зазвичай починається з: 94, 93, 92, 95, 96, 82, 70, 14, 03
  // Довжина — від 20 до 22 цифр

  if (upsRegex.test(tracking)) {
    return `https://www.ups.com/track?loc=en_US&requester=QUIC&tracknum=${tracking}/trackdetails`;
  }

  if (uspsRegex.test(tracking)) {
    return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${tracking}`;
  }

  return `https://www.fedex.com/fedextrack/no-results-found?trknbr=${tracking}`;
};

export default prepareProviderLink;
